import { Button } from 'blaze-ui/Button'
import Styles from './AutopilotProUpgradeButton.module.scss'
import { useOpenAutopilotUpgrade } from 'hooks/useOpenAutopilotUpgrade'
import cx from 'classnames'
import LockOpen3 from 'blaze-ui/icons/24/LockOpen3'

interface AutopilotProUpgradeButtonProps {
  className?: string
  variant?: 'pro' | 'upgrade'
  children?: React.ReactNode
}

export const AutopilotProUpgradeButton = ({ className, variant = 'pro', children }: AutopilotProUpgradeButtonProps) => {
  const openVirtualMarketerPlansModal = useOpenAutopilotUpgrade()

  return (
    <Button
      frontIcon={LockOpen3}
      onPress={openVirtualMarketerPlansModal}
      className={cx(Styles.upgradeButton, className, Styles[variant])}
      color="#6A00FF"
    >
      {children ?? 'Upgrade'}
    </Button>
  )
}
